import borders from './borders'
import colors from './colors'
import radius from './radius'
import shadows from './shadows'
import spacing from './spacing'
import iconsSize from './icons-size'
import fontWeights from './font-weights'
import {DeepPartial, SemanticsObject} from '../types/semantics.types'

const semanticOverrides: DeepPartial<SemanticsObject> = {
    colors: {
        text: {
            primary: colors['brand-primary'][100],
            secondary: colors.black[70],
            tertiary: colors['brand-secondary'][100],
            'accent-01': colors['brand-secondary'][100],
            'accent-02': colors['brand-tertiary'][100],
            'accent-03': colors['brand-quaternary'][100],
            'accent-04': colors['brand-quinary'][100],
        },
        border: {
            default: colors.borderDark,
            light: colors.borderLight,
            dark: colors.black[70],
            inverse: colors['border-inverse'],
        },
        background: {
            brand: colors['brand-primary'][100],
            grey: colors.black[90],
            'light-blue': colors.black[10],
            'brand-secondary-opacy': colors['brand-primary-opacity'],
        },
        button: {
            text: {
                'primary-disabled': colors.black[70],
                'secondary-default': colors['brand-primary'][100],
                'secondary-hover': colors.white,
                'secondary-focused': colors.black[100],
                'secondary-disabled': colors.black[70],
                'secondary-pressed': colors.white,
                'icon-default': colors['brand-primary'][100],
                'icon-hover': colors['brand-primary'][80],
                'icon-disabled': colors.black[50],
                'icon-pressed': colors['brand-secondary'][100],
                'text-default': colors['brand-primary'][100],
                'text-hover': colors['brand-primary'][100],
                // inverse
                'inverse-primary-disabled': colors.black[70],
                'inverse-secondary-default': colors.white,
                'inverse-secondary-hover': colors.white,
                'inverse-secondary-focused': colors.white,
                'inverse-secondary-disabled': colors.black[70],
                'inverse-secondary-pressed': colors['brand-secondary'][100],
                'inverse-icon-hover': colors.black[20],
                'inverse-icon-disabled': colors.black[50],
                'inverse-icon-pressed': colors['brand-secondary'][100],
                'inverse-text-hover': colors.white,
            },
            background: {
                'primary-pressed': colors['brand-secondary'][100],
                'secondary-default': colors.white,
                'secondary-hover': colors.black[100],
                'secondary-focused': colors.black[10],
                // inverse
                'inverse-primary-hover': colors.black[20],
                'inverse-primary-disabled': colors.black[20],
                'inverse-primary-pressed': colors['brand-secondary'][100],
                'inverse-secondary-default': colors.null,
                'inverse-secondary-hover': colors.null,
                'inverse-secondary-focused': colors.null,
            },
            border: {
                'secondary-default': colors['brand-primary'][100],
                'secondary-hover': colors.borderDark,
                'secondary-focused': colors['brand-primary'][100],
                'secondary-pressed': colors['brand-secondary'][100],
                // inverse
                'inverse-secondary-hover': colors.white,
                'inverse-secondary-focused': colors.white,
                'inverse-secondary-disabled': colors.white,
                'inverse-icon-pressed': colors['brand-secondary'][100],
            },
            'button-shop-default': colors.buttonShopDefault,
        },
        label: {
            text: {
                secondary: colors.white,
                disable: colors.black[50],
                'accent-01': colors.white,
                'accent-02': colors.white,
                'accent-03': colors.white,
                'accent-04': colors.white,
                primary: colors.white,
                success: colors.success[100],
                danger: colors.danger[100],
                tertiary: colors.white,
                quaternary: colors.white,
                quinary: colors.white,
            },
            background: {
                secondary: colors.black[100],
                disable: colors.black[10],
                'accent-01': colors['brand-secondary'][100],
                'accent-02': colors['brand-tertiary'][100],
                'accent-03': colors['brand-quaternary'][100],
                'accent-04': colors['brand-quinary'][100],
                primary: colors['brand-secondary'][100],
                success: colors.success[60],
                danger: colors.danger[60],
                tertiary: colors['brand-tertiary'][100],
                quaternary: colors['brand-quaternary'][100],
                quinary: colors['brand-quinary'][100],
            },
        },
        icons: {
            text: {
                tertiary: colors['brand-secondary'][100],
                disable: colors.black[70],
            },
            background: {
                tertiary: colors['brand-secondary'][100],
                disable: colors.black[50],
            },
        },
    },
    borders: {
        button: {
            border: {
                'secondary-hover': borders.large,
                'secondary-pressed': borders.small,
                //inverse
                'inverse-secondary-hover': borders.large,
                'inverse-secondary-pressed': borders.small,
            },
        },
    },
    radii: {
        button: {
            radius: {
                'primary-pressed': radius.button,
                'secondary-pressed': radius.button,
                //inverse
                'inverse-primary-pressed': radius.button,
                'inverse-secondary-pressed': radius.button,
            },
        },
    },
}

export {borders, colors, radius, shadows, spacing, iconsSize, semanticOverrides, fontWeights}
